import React from "react";
import { DataTable } from "best-common-react";

const cols = [
  {
    key: "event_name",
    name: "Event",
    sortable: true
  },
  {
    key: "section_name",
    name: "Section",
    sortable: true
  },
  {
    key: "row_name",
    name: "Row",
    sortable: true
  },

  {
    key: "seat_num",
    name: "First",
    sortable: true
  },
  {
    key: "last_seat",
    name: "Last",
    sortable: true
  },
  {
    key: "forwarding_allowed_ind",
    name: "Can Forward",
    sortable: true
  },
  {
    key: "plan_name",
    name: "Plan",
    sortable: true
  }
];

function TicketmasterSearchResults(params) {
  if (!params.results) {
    return <div>Table</div>;
  }

  return <DataTable id="tmResults" data={params.results} columns={cols} height={400} selectAll={false} />;
}

export default TicketmasterSearchResults;
